import React, {Component} from "react";

class CastellatedHoles extends Component{

    render() {
        return(
            <div className="container-fluid">
                基板側面に半円のスルーホール形状を加工しメタライズすることで基板の表裏の導通が取れます。穴のサイズは最小で0.6 mm必要です、穴の間のスペースも最小で0.6 mm必要です。
            </div>
        );
    }
}
export default CastellatedHoles;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/CastellatedHoles.js